import PropTypes from "prop-types";
import BaseComponent from "../../../../../lib/components/BaseComponent";
import HorizontalLayout from "../../../../../lib/components/layouts/HorizontalLayout";
import {AddBox, Close, FolderCopy} from "@mui/icons-material";
import {IconButton} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

class CommandBar extends BaseComponent {

  render() {
    return <HorizontalLayout className='items-center' widthFit>
      <Tooltip title='Abfrage entfernen'>
        <IconButton size='small' onClick={(e) => this.props.fieldPredicateRef.current.removeSelf(e)}>
          <Close/>
        </IconButton>
      </Tooltip>
      <Tooltip title='Neue Abfrage'>
        <IconButton size='small' onClick={(e) => this.props.fieldPredicateRef.current.addFieldPredicate(e)}>
          <AddBox/>
        </IconButton>
      </Tooltip>
      <Tooltip title='Abfragegruppe hinzufügen'>
        <IconButton size='small' onClick={(e) => this.props.fieldPredicateRef.current.addBooleanPredicate(e)}>
          <FolderCopy/>
        </IconButton>
      </Tooltip>
    </HorizontalLayout>;
  }
}

CommandBar.propTypes = {
  fieldPredicateRef: PropTypes.object
}
export default CommandBar;
